import React from "react";
import Table from "react-bootstrap/Table";
import Dropdown from "react-bootstrap/Dropdown";
import search from "../../assests/search.svg";
import filter from "../../assests/filterIcon.svg";
import LoadingSpinner from "../Loading/component";
import "./AddCohort.css";

export const AddCohortComp = ({
  loading,
  Search,
  filterCohortData,
  handleClick,
  stagecohortsTypes,
  handleCohortTypeClick,
  activeCohortType,
}) => {
  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <div className="add-cohort-container">
          <div className="add-cohort-search">
            <input
              type="search"
              placeholder="Search by Cohort Name/ Cohort ID"
              onChange={(e) => Search(e.target.value)}
            />
            <img src={search} alt="Search" />
          </div>

          <div className="add-cohort-table-container">
            <Table striped hover>
              <thead>
                <tr>
                  <th>Cohort ID</th>
                  <th>Cohort Name</th>
                  <th>Area Name</th>
                  <th>
                    <Dropdown className="add-cohort-filter">
                      <Dropdown.Toggle variant="none">
                        <img src={filter} alt="Filter" />
                        <span>Cohort Type</span>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {stagecohortsTypes?.map((item) => (
                          <Dropdown.Item
                            key={item.id}
                            active={activeCohortType === item.id}
                            onClick={() => handleCohortTypeClick(item.id, item.type)}
                          >
                            {item.name}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </th>
                  <th>Select</th>
                </tr>
              </thead>
              <tbody>
                {filterCohortData?.map((el) => (
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.name}</td>
                    <td>{el.area_name}</td>
                    <td>{el.type}</td>
                    <td>
                      <input
                        type="checkbox"
                        id={el.id}
                        onClick={handleClick}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      )}
    </>
  );
};